import { H7 } from 'foundations-components/transitional/components/H7';
import { AcademyRedirectLink } from '../../dynamicContentWidget/components/AcademyRedirectLink';
import { Video } from './Video';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultContentNameComponent = ({
  children
}) => /*#__PURE__*/_jsx(H7, {
  "data-test-id": "embedded-academy-video-title",
  marginBlockEnd: "300",
  marginBlockStart: "400",
  children: children
});
const DefaultContentDescriptionComponent = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "p",
  "data-test-id": "embedded-academy-video-description",
  marginBlockEnd: "200",
  children: children
});
export const VideoSection = ({
  isResizeReady = true,
  lessonId,
  contentId,
  shortId,
  videoTimestamp,
  contentName,
  contentDescription,
  isPublic = false,
  language,
  link,
  LinkComponent,
  ContentNameComponent = DefaultContentNameComponent,
  ContentDescriptionComponent = DefaultContentDescriptionComponent,
  onLinkClick,
  onPlay,
  onFinish,
  onEngagement,
  renderContext = 'embedded-academy',
  creatorHubId,
  enablePictureInPicture,
  hublet,
  videoType
}) => {
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx(Video, {
      contentId: contentId,
      creatorHubId: creatorHubId,
      enablePictureInPicture: enablePictureInPicture,
      hublet: hublet,
      isPublic: isPublic,
      language: language,
      lessonId: lessonId,
      link: link,
      onEngagement: onEngagement,
      onFinish: onFinish,
      onPlay: onPlay,
      renderContext: renderContext,
      shortId: shortId,
      startTime: videoTimestamp,
      videoType: videoType
    }), isResizeReady !== false && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ContentNameComponent, {
        children: contentName
      }), contentDescription && /*#__PURE__*/_jsx(ContentDescriptionComponent, {
        children: contentDescription
      }), /*#__PURE__*/_jsx(AcademyRedirectLink, {
        LinkComponent: LinkComponent,
        isPublic: isPublic,
        language: language,
        lessonId: lessonId,
        link: link,
        onClick: onLinkClick,
        shortId: shortId
      })]
    })]
  });
};